const PUBLIC_AUTH_ROUTE_PATTERNS = [
    /^\/auth\/login$/,
    /^\/auth\/register$/,
    /^\/auth\/[^/]+\/register\/partner\/candidate$/,
    /^\/auth\/password\/reset\/request$/,
    /^\/auth\/password\/reset\/[^/]+$/,
    /^\/auth\/email\/verify\/[^/]+$/,
    /^\/auth\/invitation\/accept\/[^/]+$/,
]

const normalizePublicAuthPath = (url: string): string => {
    const pathname = new URL(url, window.location.origin).pathname
    return pathname.replace(/^\/(?:admin|partner|support|userapp)\/api(?=\/)/, '').replace(/^\/api(?=\/)/, '')
}

const isPublicAuthRoute = (url: string): boolean => {
    const pathname = normalizePublicAuthPath(url)
    return PUBLIC_AUTH_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname))
}

export default isPublicAuthRoute
